import { useMenu } from '@if/mui'
import { Button, Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'

const LoanMenu = () => {
  const { t } = useTranslation()
  const [buttonProps, menuProps] = useMenu()

  return (
    <>
      <Button {...buttonProps}>{t('menus.loans.loans')}</Button>
      <Menu {...menuProps}>
        <MenuItem>{t('menus.loans.toCollect')}</MenuItem>
        <MenuItem>{t('menus.loans.collectionHistory')}</MenuItem>
        <MenuItem>{t('menus.loans.paymentHolidayHistory')}</MenuItem>
        <MenuItem>{t('menus.loans.reportAndExportation')}</MenuItem>
        <MenuItem>{t('menus.loans.metro2')}</MenuItem>
      </Menu>
    </>
  )
}

export default LoanMenu
